import React, { useEffect, useState } from 'react';
import { Card, CardContent } from '../../ui/card';
import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem } from '../../ui/dropdown-menu';
import { Plus, Trash2, Edit2, User, ChevronDown, ChevronRight } from 'lucide-react';
import { useSupabase } from '../../../contexts/SupabaseContext';
import DecisionNode from './DecisionNode';
// import { motion, AnimatePresence } from 'framer-motion'; // Uncomment if using framer-motion

const DecisionTree: React.FC = () => {
  const {
    decisions,
    loadDecisions,
    createDecision,
    updateDecision,
    deleteDecision,
    decisionOptions,
    loadDecisionOptions,
    createDecisionOption,
    updateDecisionOption,
    deleteDecisionOption,
    decisionOptionPoints,
    loadDecisionOptionPoints,
    createDecisionOptionPoint,
    updateDecisionOptionPoint,
    deleteDecisionOptionPoint,
  } = useSupabase();

  const [expanded, setExpanded] = useState<Record<string, boolean>>({});
  const [newRootTitle, setNewRootTitle] = useState('');

  useEffect(() => {
    loadDecisions();
  }, [loadDecisions]);

  const getRootDecisions = () => decisions.filter((d) => d.parent_id === null);

  return (
    <div className="p-6 max-w-4xl mx-auto">
      {/* Removed static header */}
      <div className="flex gap-2 mb-6">
        <Input
          value={newRootTitle}
          onChange={(e) => setNewRootTitle(e.target.value)}
          placeholder="Add new decision..."
          onKeyDown={async (e) => {
            if (e.key === 'Enter' && newRootTitle.trim()) {
              await createDecision({ title: newRootTitle });
              setNewRootTitle('');
            }
          }}
          className="w-64"
        />
        <Button onClick={async () => {
          if (newRootTitle.trim()) {
            await createDecision({ title: newRootTitle });
            setNewRootTitle('');
          }
        }}>
          <Plus size={16} />
        </Button>
      </div>
      <div className="space-y-4">
        {getRootDecisions().map((decision) => (
          <DecisionNode
            key={decision.id}
            decision={decision}
            depth={0}
            expanded={expanded}
            setExpanded={setExpanded}
          />
        ))}
      </div>
    </div>
  );
};

export default DecisionTree; 